// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2svJb","range":"MonthRangeSwitch_range__FyGfx","disabled":"MonthRangeSwitch_disabled__3-L4s"};